import { useMemo } from 'react';

import { ApiSectionNamespace } from '@api';
import { ELogLevel, LoggerType } from '@services/errorService';
import {
  useHttpClientAsync,
  EHttpClient,
  httpMethods,
  IHttpClientResponse,
  IGeneralRequestResponse,
} from '@services/httpClientService';
import { isObjectEmpty } from '@utils/general';

import { IValidatedLastOrder, IValidatedLastOrderResponse } from '../../../model';

import { decodeLastOrderFromDto } from './decoder';

const mappingFunctionCheckout = (
  result: IGeneralRequestResponse<IValidatedLastOrderResponse>,
  callLogger: LoggerType,
): IValidatedLastOrder | null => {
  if (!result || isObjectEmpty(result) || !result.data?.lastOrder) {
    return null;
  }

  const record = decodeLastOrderFromDto(result.data);

  if (!record) {
    callLogger({
      logLevel: ELogLevel.WARNING,
      logMessage: 'Unable to decode data Last Order from response.',
      additionalData: [{ key: 'Validated last order data from Checkout GW', data: result }],
    });
  }
  return record;
};

export const useValidateLastOrderOnDemand = (): IHttpClientResponse<IValidatedLastOrder> => {
  const checkoutClient = useHttpClientAsync<
    IValidatedLastOrder,
    null,
    IGeneralRequestResponse<IValidatedLastOrderResponse>
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EOrderAsLastTimeApiKeys.ORDER_AS_LAST_TIME_VALIDATE_LAST_ORDER_URL,
    mappingFunction: mappingFunctionCheckout,
    httpClientType: EHttpClient.CHECKOUT_GATEWAY,
  });

  return useMemo(() => checkoutClient, [checkoutClient]);
};
